function Home() {
    return <h1>This is Home page!</h1>;
}

export default Home;